module.exports = {
      id: "text-usage",
      viewBox: "0 0 18.361 15.287",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#text",
      toString: function () {
        return this.url;
      }
    }